const defaultTheme = require('tailwindcss/defaultTheme')

const defaults = ({ exclude, from }) => {
  return Object.keys(defaultTheme[from]).reduce((config, key) => {
    if (!exclude.includes(key)) {
      config[key] = defaultTheme[from][key]
    }
    return config
  }, {})
}

const tailwindForms = require('./tailwind.forms')

module.exports = {
  content: [
    './vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php',
    './storage/framework/views/*.php',
    './resources/views/**/*.blade.php',
    './resources/js/**/*.vue'
  ],

  theme: {
    colors: {
      navy: {
        600: 'var(--navy-600)',
        400: 'var(--navy-400)',
        200: 'var(--navy-200)'
      },
      blue: {
        600: 'var(--blue-600)',
        400: 'var(--blue-400)',
        200: 'var(--blue-200)'
      },
      yellow: {
        600: 'var(--yellow-600)',
        400: 'var(--yellow-400)',
        200: 'var(--yellow-200)'
      },
      red: {
        600: 'var(--red-600)',
        400: 'var(--red-400)',
        200: 'var(--red-200)'
      },
      green: {
        600: 'var(--green-600)',
        400: 'var(--green-400)',
        200: 'var(--green-200)'
      },
      gray: {
        800: 'var(--gray-800)',
        700: 'var(--gray-700)',
        600: 'var(--gray-600)',
        500: 'var(--gray-500)',
        400: 'var(--gray-400)',
        300: 'var(--gray-300)',
        200: 'var(--gray-200)',
        100: 'var(--gray-100)'
      },
      transparent: 'transparent',
      inherit: 'inherit'
    },

    fontWeight: defaults({ exclude: ['thin', 'extralight'], from: 'fontWeight' }),

    letterSpacing: {
      tightest: '-.075em',
      tighter: '-.05em',
      tight: '-.025em',
      normal: '0',
      wide: '.025em',
      wider: '.05em',
      widest: '.25em'
    },

    extend: {
      fontSize: {
        xxs: ['0.702rem', { lineHeight: '1rem' }]
      },
      fontFamily: {
        sans: ['DM Sans', ...defaultTheme.fontFamily.sans]
      },
      transitionTimingFunction: {
        'in-out-circ': 'cubic-bezier( 0.785, 0.135, 0.15, 0.86 )'
      },
      boxShadow: {
        dialog: '0 2px 74px 0 rgba(0,0,0,0.23)'
      }
    }
  },

  plugins: [tailwindForms]
}
